



































































import Vue from "vue";
import {
  UsePopup,
  PopupConfig,
  PopupPosition,
  PopupResult,
} from "./popup.state";
import {
  ref,
  Ref,
  reactive,
  onMounted,
  onBeforeUnmount,
} from "@vue/composition-api";
import { isClickOutsideRect, onKey } from "@/common/dom.functions";
import { delayBy, emptyFn } from "@/fp";
export default Vue.extend({
  setup() {
    let closeListener: Function;
    const isActionPopup = ref(false);
    const isShow: Ref<boolean> = ref(false);
    const popupConfig: Ref<PopupConfig> = ref({});
    const lastId = ref(0);

    const position = reactive({
      top: 0,
      left: 0,
    });

    let onClickListener = (ev: Event) => {
      /*  */
    };
    let onScrollListener = (ev: Event) => {
      /*  */
    };

    let sessionResolver: (result: PopupResult) => void = () => {
      /*  */
    };

    const closePopup = () => {
      window.removeEventListener("click", onClickListener);
      window.removeEventListener("scroll", onScrollListener, {
        capture: true,
      });
      isShow.value = false;
      if (isActionPopup.value) {
        sessionResolver({
          type: "canceled",
        });
      } else {
        closeListener && closeListener();
      }
    };

    const createOnScrollListener = (id: number) => {
      return (ev: Event) => {
        if (id === lastId.value) {
          const el = document.querySelector(".the-app-popup");
          if (el) {
            const isOutside = isClickOutsideRect(el)(ev as MouseEvent);
            if (isOutside && !popupConfig.value.preventOnScrollClose) {
              closePopup();
            }
          } else {
            closePopup();
          }
        }
      };
    };

    const createListener = (id: number) => {
      return (ev: Event) => {
        if (id === lastId.value) {
          const el = document.querySelector(".the-app-popup");
          if (el) {
            const isOutside = isClickOutsideRect(el)(ev as MouseEvent);
            if (isOutside) {
              closePopup();
            }
          } else {
            closePopup();
          }
        }
      };
    };

    const isOverflowY = ref(false);

    const setPosition = async (pos: PopupPosition, el: HTMLElement) => {
      await delayBy(isShow.value ? 0 : 200);
      const { top, bottom, left } = el.getBoundingClientRect();
      let popupHeight = 0;
      try {
        const { height } = (document.querySelector(
          "#the-popup"
        ) as HTMLElement).getBoundingClientRect();
        popupHeight = height;
      } catch (e) {
        //
      }

      switch (pos) {
        case "top":
          position.top = top - (popupConfig.value.height || popupHeight || 0);
          position.left = left;
          break;
        case "left":
          position.top = top - (popupConfig.value.height || 0);
          position.left = left - popupConfig.value.width;
          break;
        case "top-left":
          position.top = top - (popupConfig.value.height || 0);
          position.left = left - popupConfig.value.width;
          break;
        case "bottom-left":
          position.top = bottom;
          position.left = left - popupConfig.value.width;
          break;
        case "right":
          position.top = top - (popupConfig.value.height || 0);
          position.left = left + el.offsetWidth;
          break;
        case "bottom":
        default:
          position.top = bottom;
          position.left = left;
          break;
      }

      {
        setTimeout(() => {
          const { bottom: popupBottom, height } = (document.querySelector(
            "#the-popup"
          ) as HTMLElement).getBoundingClientRect();
          popupHeight = height;
          const delteaBottom = popupBottom - window.innerHeight;
          isOverflowY.value = delteaBottom >= 0;
          if (isOverflowY.value) {
            position.top -= delteaBottom + 10;
          }
        }, 100);
      }
    };

    const initPopup = async (config: PopupConfig) => {
      lastId.value++;
      popupConfig.value = config;
      const triggerEl =
        (config.event.currentTarget as HTMLElement) ||
        (config.event.target as HTMLElement);
      window.removeEventListener("click", onClickListener);
      window.removeEventListener("scroll", onScrollListener, {
        capture: true,
      });

      isShow.value = true;
      setTimeout(() => {
        onClickListener = createListener(lastId.value);
        onScrollListener = createOnScrollListener(lastId.value);
        window.addEventListener("click", onClickListener);
        window.addEventListener("scroll", onScrollListener, {
          capture: true,
        });
      }, 200);
      console.log("config.position, triggerEl", config.position, triggerEl);
      setPosition(config.position, triggerEl);
    };

    UsePopup.setRootListener(
      (config, cb) => {
        closeListener = cb;
        isActionPopup.value = false;
        initPopup(config);
      },
      (config) => {
        isActionPopup.value = true;
        initPopup(config);
        return new Promise((resolve) => {
          sessionResolver = resolve;
        });
      }
    );

    const onAction = (actionName: string) => {
      window.removeEventListener("click", onClickListener);
      window.removeEventListener("scroll", onScrollListener, {
        capture: true,
      });
      isShow.value = false;
      sessionResolver({
        type: "success",
        action: actionName,
      });
    };

    const on_item_clicked = (action: string) => {
      if (isActionPopup.value) {
        onAction(action);
      }
    };

    const subs = {
      esc: emptyFn(),
    };

    onMounted(() => {
      subs.esc = onKey("Escape")(() => {
        if (isShow.value) {
          closePopup();
        }
      });
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      popupConfig,
      isShow,
      position,
      onAction,
      isOverflowY,
      isActionPopup,
      on_item_clicked,
    };
  },
});
